import React, { useEffect, useState, useCallback } from "react";
import Seo from '../components/Seo';
import { useNavigate } from "react-router-dom";
import API from "../utils/api";
import "../styles/board.css";

function Board() {
  const [boards, setBoards] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");       // 입력값
  const [searchType, setSearchType] = useState("TITLE");
  const [applied, setApplied] = useState({ term: "", type: "TITLE" }); // 실제 적용된 검색
  const [page, setPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoggedIn(!!localStorage.getItem("accessToken"));
  }, []);

  const fetchBoards = useCallback(async (targetPage, term, type) => {
    try {
      setLoading(true);
      const res = await API.get("/boards", {
        params: { page: targetPage, size: 10, search: term, searchType: type },
      });
      const content = res.data?.content;
      if (content && Array.isArray(content.list)) {
        setBoards(content.list);
        setHasNextPage(content.page < content.totalPage);
      } else {
        setBoards([]);
        setHasNextPage(false);
      }
    } catch (err) {
      setBoards([]);
      setHasNextPage(false);
    } finally {
      setLoading(false);
    }
  }, []);

  // 페이지 변경 또는 검색 적용 시에만 조회 (키 입력마다 조회하지 않음)
  useEffect(() => {
    fetchBoards(page, applied.term, applied.type);
  }, [page, applied, fetchBoards]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    setApplied({ term: searchTerm.trim(), type: searchType });
  };

  return (
    <div className="board-page container section">
      <Seo
        title="게시판"
        description="이지랩의 소식과 공지사항을 전합니다."
        path="/board"
      />
      <header className="board-head">
        <div>
          <span className="section__eyebrow">Board</span>
          <h1 className="board-head__title">게시판</h1>
        </div>
        {isLoggedIn && (
          <button className="btn btn--primary btn--sm" onClick={() => navigate("/board/write")}>
            글쓰기
          </button>
        )}
      </header>

      <form className="board-search" onSubmit={handleSearch}>
        <select
          className="select board-search__type"
          value={searchType}
          onChange={(e) => setSearchType(e.target.value)}
        >
          <option value="TITLE">제목</option>
          <option value="AUTHOR">작성자</option>
          <option value="ALL">제목+작성자</option>
        </select>
        <input
          className="input board-search__input"
          type="text"
          placeholder={searchType === "AUTHOR" ? "작성자로 검색" : "제목으로 검색"}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button type="submit" className="btn btn--outline">검색</button>
      </form>

      {loading ? (
        <div className="state-block">
          <div className="spinner" />
          불러오는 중...
        </div>
      ) : boards.length > 0 ? (
        <ul className="board-list">
          {boards.map((board) => (
            <li key={board.id} className="board-row" onClick={() => navigate(`/board/${board.id}`)}>
              <span className="board-row__title">{board.title}</span>
              <span className="board-row__meta">{board.author} · 조회 {board.viewCount}</span>
            </li>
          ))}
        </ul>
      ) : (
        <div className="state-block">
          <p className="state-block__title">게시글이 없습니다</p>
        </div>
      )}

      <div className="board-pagination">
        <button className="btn btn--outline btn--sm" disabled={page === 1} onClick={() => setPage((p) => p - 1)}>
          ◀ 이전
        </button>
        <span className="pagination__info">{page} 페이지</span>
        <button className="btn btn--outline btn--sm" disabled={!hasNextPage} onClick={() => setPage((p) => p + 1)}>
          다음 ▶
        </button>
      </div>
    </div>
  );
}

export default Board;
